export default __webpack_public_path__ + "static/media/DB_1.e8d8085e.png";